import { IHCPFlowKanbanColumn } from './hcp-flow.interface'

export function replaceKanbanColumns(incoming: IHCPFlowKanbanColumn[]): IHCPFlowKanbanColumn[] {
  return incoming
}

export function appendColumnPage(
  current: IHCPFlowKanbanColumn[],
  incoming: IHCPFlowKanbanColumn[],
  targetStatusId: string
): IHCPFlowKanbanColumn[] {
  const incomingColumn = incoming.find((column) => column.statusId === targetStatusId)
  if (!incomingColumn) return current

  return current.map((column) => {
    if (column.statusId !== targetStatusId) return column

    const existingIds = new Set(column.cards.map((card) => String(card.id)))
    const newCards = incomingColumn.cards.filter((card) => !existingIds.has(String(card.id)))

    return {
      ...incomingColumn,
      cards: [...column.cards, ...newCards],
    }
  })
}

export function getNextColumnPage(column: IHCPFlowKanbanColumn): number {
  return (column.page ?? 1) + 1
}

export function getColumnLoadMoreLabel(column: IHCPFlowKanbanColumn): string {
  const loaded = column.cards.length
  const total = column.total

  if (total > loaded) {
    return `Carregar mais (${loaded.toLocaleString('pt-BR')} de ${total.toLocaleString('pt-BR')})`
  }

  return 'Carregar mais'
}
